import type { IconTypes } from "../../Icons";

export type ToolbarAction = "heading" | "bold" | "highlight" | "list" | "insert-link";

type BaseAction = Exclude<ToolbarAction, "bold" | "highlight">;

// Bold and highlight both map to <strong> — enable one or neither, never both.
export type EnabledActions =
  | BaseAction[]
  | (BaseAction | "bold")[]
  | (BaseAction | "highlight")[];

export interface ToolbarItem {
  id: string;
  text: string;
  iconType: IconTypes;
  action: ToolbarAction;
  showDividerAfter?: boolean;
}

export interface ActiveFormats {
  heading: boolean;
  bold: boolean;
  list: boolean;
}

export const DEFAULT_ACTIVE_FORMATS: ActiveFormats = {
  heading: false,
  bold: false,
  list: false,
};

// Default toolbar matches typical question content fields in v1 (bold, not highlight).
export const ALL_TOOLBAR_ACTIONS: EnabledActions = [
  "heading",
  "bold",
  "list",
  "insert-link",
];

export const TOOLBAR_ITEMS: ToolbarItem[] = [
  { id: "heading", text: "Header", iconType: "Header2", action: "heading" },
  { id: "bold", text: "Bold", iconType: "BoldIcon", action: "bold" },
  {
    id: "highlight",
    text: "Highlight",
    iconType: "HighlightIcon",
    action: "highlight",
    showDividerAfter: true,
  },
  {
    id: "list",
    text: "List",
    iconType: "ListBulletedIcon",
    action: "list",
    showDividerAfter: true,
  },
  {
    id: "insert-link",
    text: "Insert link",
    iconType: "Link",
    action: "insert-link",
  },
];
